// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const DemoRentalHistoryDealerCriteria = props => {

    const dealerSelectionMessage = props.dealers.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <div className='demo-rental-history-dealer-criteria'>
            <CheckboxListWithLabel
                className='demo-rental-history-dealers'
                initialState={createHashMap(props.dealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.allowedAccounts)}
                onChange={props.onSelectedAccountsChange}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </div>);

};

DemoRentalHistoryDealerCriteria.displayName = 'DemoRentalHistoryDealerCriteria';
DemoRentalHistoryDealerCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    onSelectedAccountsChange: PropTypes.func.isRequired
};

export default DemoRentalHistoryDealerCriteria;




// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-dealer-criteria.js